/**
 * Словарь «код → подпись» для экспортируемых наружу таблиц слов.
 *
 * Многие модули экспортируют `Record<код, string>` (`CASE_STATE_WORD[code]`),
 * и их читают десятки экранов. Строку нельзя вычислить при загрузке модуля —
 * она застынет на языке первой загрузки (ADR-0019). Поэтому значения здесь
 * берутся геттером: `tr(...)` вызывается в момент обращения `WORDS[code]`, а
 * сам словарь остаётся прежним `Record<код, string>` для всех читателей.
 */
import type { Message } from '../../i18n/define';
import { tr } from '../../i18n/runtime';

export function lazyWords<K extends string>(messages: Record<K, Message>): Record<K, string> {
  const out = {} as Record<K, string>;
  for (const key of Object.keys(messages) as K[]) {
    Object.defineProperty(out, key, { enumerable: true, get: () => tr(messages[key]) });
  }
  return out;
}
